var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"prod-20250930041136"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/b";

import * as Sentry from '@sentry/nextjs';
import fileVersion from './fileVersion';

// 取得構建環境
const buildEnv = process.env.BUILD_ENV || process.env.APP_ENV || 'development';
const dsnEnv = {
  'prod': 'https://edef6c2898fbde133fc98ae267cc5c5d@ingest.ingtracer.com/10',
  'uat': 'https://3a0ced45c9fd8360aa07c730dd0bb9c3@sentry.sit.oneops.net/4',
}

Sentry.init({
  dsn: dsnEnv[buildEnv] || dsnEnv.uat,
  
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,
  
  debug: false,
  
  // Session Replay is disabled to reduce performance overhead and Sentry quota usage
  // replaysOnErrorSampleRate: 1.0,
  
  // replaysSessionSampleRate: 0.1,
  
  // integrations: [
  //   Sentry.replayIntegration({
  //     maskAllText: true,
  //     blockAllMedia: true,
  //   }),
  // ],
  
  // Environment - 使用 BUILD_ENV
  environment: buildEnv,
  
  // Release tracking - 使用動態版本號加環境前綴
  release: `${buildEnv}-${fileVersion || '1.0.0'}`,
  
  // Filter out certain errors
  beforeSend(event) {
    // Don't send events in development unless explicitly enabled
    if (process.env.NODE_ENV === 'development' && !process.env.NEXT_PUBLIC_SENTRY_DEBUG) {
      return null;
    }
    
    // Filter out certain error types
    if (event.exception) {
      const error = event.exception.values?.[0];
      if (error?.type === 'ChunkLoadError' || 
          error?.type === 'ResizeObserver loop limit exceeded' ||
          error?.value?.includes('Non-Error promise rejection')) {
        return null;
      }
    }
    
    return event;
  },
  
  // Additional context
  initialScope: {
    tags: {
      component: 'client',
    },
  },
});